import { Trash2Icon, XIcon } from "lucide-react";
import { useMutation, useQueryClient } from "tanstack-react-query-5";

import { useRouterBack } from "@/shared-web.ui/hook.use-router-back";
import { Checkbox } from "@/shared-web.ui/ui.checkbox";
import { Flex } from "@/shared-web.ui/ui.flex";
import { IconButton } from "@/shared-web.ui/ui.icon-button";
import { Text } from "@/shared-web.ui/ui.text";
import { cn } from "@/shared-web.ui/util.cn";
import { removeItems } from "@/stf.data/request.cart";

import { useCartContext } from "./cart.context";
import { reduceAllState } from "./hook.use-cart";

interface CartHeaderProps {
  className?: string;
}
const CartHeader = (props: CartHeaderProps) => {
  const { className } = props;
  const { routerBack } = useRouterBack();

  const {
    cartState: {
      cartData,
      selectedCartItemId,
    },
    dispatchCartAction,
  } = useCartContext();

  const selectAllState = reduceAllState({
    cartData,
    selectedCartItemId,
  });

  const queryClient = useQueryClient();

  const { mutate: mutateRemoveItem } = useMutation({
    mutationFn: removeItems,
    onSettled: async () => {
      await queryClient.invalidateQueries(
        { queryKey: ["getCart"] },
      );
    },
  });

  const handleClose = () => {
    routerBack();
  };

  const handleToggleAll = () => {
    dispatchCartAction({
      type: "toggleAll",
    });
  };

  const removeSelectItem = () => {
    mutateRemoveItem({
      cartItemIds: selectedCartItemId,
    });
  };

  return (
    <Flex
      className={cn(
        "bg-accent-2",
        className,
      )}
      direction="column"
      gap="3"
      p="3"
    >
      <Flex
        align="baseline"
        justify="between"
      >
        <Text
          semanticColor="accent"
          size="4"
          weight="medium"
        >
          My Cart
        </Text>
        <IconButton
          color="gray"
          onClick={handleClose}
          radius="full"
          size="3"
          variant="ghost"
          screenReaders="Close cart"
        >
          <XIcon size="1rem" />
        </IconButton>
      </Flex>
      <Flex
        align="center"
        justify="between"
      >
        <Flex
          align="center"
          gap="2"
        >
          <Checkbox
            checked={selectAllState}
            onCheckedChange={handleToggleAll}
            size="2"
          />
          <Text
            color="gray"
            size="2"
          >
            Select All
          </Text>
        </Flex>
        <Flex>
          <IconButton
            color="gray"
            onClick={removeSelectItem}
            radius="full"
            variant="ghost"
            screenReaders="Remove selected items"
          >
            <Trash2Icon
              size="1rem"
            />
          </IconButton>
        </Flex>
      </Flex>
    </Flex>
  );
};

export { CartHeader };
